
export default {
  name: 'BaseNavigatorUserCard',
  props: {
    author: {
      type: Object,
      default: null,
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      streamsVisibleCount: 6,
    }
  },
  computed: {
    isHavButtons() {
      return (
        (this.author?.profile?.actionButton &&
          this.author?.profile?.actionButton?.status) ||
        this.author.statistics?.articles?.publishedCount +
          this.author.statistics?.telegram?.publishedCount >
          0 ||
        this.author.statistics.products?.publishedCount > 0 ||
        this.author.statistics.goods?.publishedCount > 0 ||
        this.author.statistics.vacancys?.publishedCount > 0 ||
        this.author.statistics.events?.publishedCount > 0
      )
    },
    streams() {
      const filteredStreams = this.author?.statistics?.forStreams?.map(
        (stream) => {
          if ('_id' in stream && 'publishedCount' in stream && stream?._id) {
            return stream._id
          } else {
            return stream
          }
        }
      )
      return filteredStreams.slice(0, this.streamsVisibleCount)
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/author', {
        username: this.author.username,
      })
    },
  },
}
